import React from 'react'
import { animated, useTransition } from 'react-spring'
import { Cycle as CycleEntity } from '../../entities/cycle/Cycle'
import CycleOrder from '../cycle-order/CycleOrderContainer'

export interface IOwnProps {
  cycle: CycleEntity
}

export type IProps = IOwnProps

const Cycle: React.FC<IProps> = (props) => {
  const {
    cycle,
  } = props

  const [transition] = useTransition(cycle.orders, {
    initial: {
      transform: 'translateX(0%)',
    },
    from: {
      transform: 'translateX(-150%)',
    },
    enter: {
      transform: 'translateX(0%)',
    },
    leave: {
      transform: 'translateX(150%)',
    },
    keys: cycle.orders.map(item => item.orderId),
    config: {
      duration: 300,
    },
    exitBeforeEnter: true,
  }, [cycle.orders.map(item => item.orderId)])

  return (
    <>
      {transition((styles, order) => (
        <animated.div style={styles}>
          <CycleOrder order={order} key={order.orderId} />
        </animated.div>
      ))}
    </>
  )
}

export default Cycle
